module.exports = __webpack_public_path__ + "static/media/image_natureworks.caef7ff9.png";